module.exports = __webpack_public_path__ + "img/flag_fr.e8d1a0eb.svg";